module.exports = ".ft-icon-search {\n  float: right;\n  position: absolute;\n  top: 7px;\n  right: 0; }\n\n.search-box {\n  padding-right: 23px; }\n\n.date-input-fields-wrap {\n  width: 50%; }\n\n.panel .panel-header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/user-order-list/user-order-list.component.scss
// module id = ./src/app/pages/user-order-list/user-order-list.component.scss
// module chunks = main